import { render } from "./about-me.vue?vue&type=template&id=91f47e16&scoped=true"
const script = {}

import "./about-me.vue?vue&type=style&index=0&id=91f47e16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f47e16"]])

export default __exports__